import { atomWithStorage } from "jotai/utils";
import type { TimeWindowRecentEntry } from "../../../../TimeWindow.recent.types";

export const timeWindowRecentAtom = atomWithStorage<TimeWindowRecentEntry[]>(
  "time-window-recent",
  []
);
